/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesGetService } from "../../funcs/computeServicesGetService.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetServiceRequest$inboundSchema,
};

export const tool$computeServicesGetService: ToolDefinition<typeof args> = {
  name: "compute-services-get-service",
  description: `Get a service`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeServicesGetService(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
